export default __webpack_public_path__ + "assets/logos-footer-faevyt.svg";